exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".group-list[data-v-626504b5]{height:100%;overflow-y:hidden;margin-right:-24px}.group-list_box[data-v-626504b5]{width:100%;height:100%;padding-right:24px}.group-list-empty[data-v-626504b5]{display:flex;align-items:center;justify-content:center}\n", ""]);

